"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_data_table_constants_1 = require("./bc-data-table-constants");
var bc_data_table_column_header_behavior_1 = require("./bc-data-table-column-header-behavior");
var bc_data_table_header_behavior_1 = require("./bc-data-table-header-behavior");
var bc_data_table_tbody_behavior_1 = require("./bc-data-table-tbody-behavior");
var bc_tooltip_behavior_1 = require("../../molecules/bc-tooltip/bc-tooltip-behavior");
var bc_float_menu_behavior_1 = require("../../organisms/bc-float-menu/bc-float-menu-behavior");
var bc_data_table_multicheck_behavior_1 = require("./bc-data-table-multicheck-behavior");
var bc_data_table_preloader_behavior_1 = require("./bc-data-table-preloader-behavior");
var bc_checkbox_behavior_1 = require("../../atoms/bc-checkbox/bc-checkbox-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_paginator_v2_behavior_1 = require("../../molecules/bc-paginator-v2/bc-paginator-v2-behavior");
var bc_data_table_total_value_behavior_1 = require("./bc-data-table-total-value-behavior");
var bc_total_value_behavior_1 = require("../../molecules/bc-total-value/bc-total-value-behavior");
var bc_tabs_group_behavior_1 = require("../../molecules/bc-tabs-group/bc-tabs-group-behavior");
var BcDataTableBehavior = (function (_super) {
    __extends(BcDataTableBehavior, _super);
    function BcDataTableBehavior(config) {
        var _this = _super.call(this) || this;
        _this.modifyRowData = function (rowData) {
            var modifiedRowData = rowData.map(_this.setCellData);
            var hasIdObject = modifiedRowData.some(function (item) { return item.type === 'id'; });
            if (!hasIdObject) {
                var randomId = _this.generateRandomIdNumber();
                var newIdObject = { type: 'id', value: randomId };
                modifiedRowData.unshift(newIdObject);
            }
            return modifiedRowData;
        };
        _this.setCellData = function (cellData) {
            var dataType = typeof cellData;
            return _this.setObjectByType(dataType, cellData);
        };
        _this.bcDataTableConfig = config;
        _this.bcDataTableMulticheckBehavior = new bc_data_table_multicheck_behavior_1.BcDataTableMulticheckBehavior(_this.bcDataTableConfig);
        _this.bcDataTableTBodyBehavior = new bc_data_table_tbody_behavior_1.BcDataTableTBodyBehavior(_this.bcDataTableConfig, _this.bcDataTableMulticheckBehavior);
        _this.bcDataTableHeaderBehavior = new bc_data_table_header_behavior_1.BcDataTableHeaderBehavior(_this.bcDataTableConfig);
        _this.bcDataTableToTalValueBehavior = new bc_data_table_total_value_behavior_1.BcDataTableToTalValueBehavior(_this.bcDataTableConfig);
        _this.bcDataTablePreloaderBehavior = new bc_data_table_preloader_behavior_1.BcDataTablePreloaderBehavior(_this.bcDataTableConfig);
        _this.bcDataTableColumnHeaderBehavior = new bc_data_table_column_header_behavior_1.BcDataTableColumnHeaderBehavior(_this.bcDataTableConfig, _this.bcDataTableTBodyBehavior, _this.bcDataTableMulticheckBehavior);
        _this.bcDataTable = document.getElementById(_this.bcDataTableConfig.id);
        _this.initDataTable();
        _this.renderTable();
        _this.removePreloader();
        _this.initEvents();
        _this.dataCopy = JSON.parse(JSON.stringify(config));
        _this.bcDataTableHeaderBehavior.bcDataTableHeaderSettingsBehavior.getDataConfigCopy(_this.dataCopy);
        return _this;
    }
    BcDataTableBehavior.prototype.initDataTable = function () {
        this.setStyles(this.bcDataTable);
        this.setTableStructure();
        this.setPreloader();
        this.setColumnDataStructure();
        this.setDataStructure();
    };
    BcDataTableBehavior.prototype.setColumnDataStructure = function () {
        if (this.bcDataTableConfig.columnHeaders) {
            this.bcDataTableConfig.columnHeaders.data.forEach(function (columnHeader) {
                columnHeader.pinned = columnHeader.pinned || false;
                columnHeader.visible = columnHeader.visible !== undefined ? columnHeader.visible : true;
            });
            this.checkPinned();
        }
    };
    BcDataTableBehavior.prototype.checkPinned = function () {
        var firstPinnedFound = false;
        for (var _i = 0, _a = this.bcDataTableConfig.columnHeaders.data; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.pinned && !firstPinnedFound) {
                firstPinnedFound = true;
                item.pinned = true;
            }
            else {
                item.pinned = false;
            }
        }
        var firstPinnedObject = this.bcDataTableConfig.columnHeaders.data.find(function (item) { return item.pinned === true; });
        if (!firstPinnedObject) {
            this.bcDataTableConfig.columnHeaders.data[0].pinned = true;
        }
    };
    BcDataTableBehavior.prototype.initEvents = function () {
        var _this = this;
        var resizeTimeout;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                _this.checkOverflow();
            }, bc_data_table_constants_1.BcDataTableConstansts.WINDOW_RESIZE_TIMEOUT);
        });
        setTimeout(function () {
            _this.checkOverflow();
        }, bc_data_table_constants_1.BcDataTableConstansts.WINDOW_RESIZE_TIMEOUT);
    };
    BcDataTableBehavior.prototype.setStyles = function (dataTable) {
        dataTable.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_CLASS);
    };
    BcDataTableBehavior.prototype.setTableStructure = function () {
        var _this = this;
        var container = this.bcDataTable.parentElement;
        if (container) {
            var divsToRemove = Array.from(container.children).filter(function (child) { return child.tagName.toLowerCase() === common_constants_1.BcCommonConstants.DIV_TAG && child !== _this.bcDataTable; });
            divsToRemove.forEach(function (div) { return div.remove(); });
        }
        this.bcDataTable.innerHTML = '';
        this.bcDataTable.createTBody();
        if (this.bcDataTableConfig.columnHeaders) {
            this.bcDataTable.createTHead();
        }
    };
    BcDataTableBehavior.prototype.generateRandomIdNumber = function () {
        return window.crypto.getRandomValues(new Uint32Array(1))[0];
    };
    BcDataTableBehavior.prototype.setDataStructure = function () {
        this.bcDataTableConfig.data = this.bcDataTableConfig.data.map(this.modifyRowData);
    };
    BcDataTableBehavior.prototype.setObjectByType = function (dataType, cellData) {
        var baseObject = {
            type: dataType,
            value: cellData
        };
        if (dataType === 'object') {
            baseObject = cellData;
        }
        return baseObject;
    };
    BcDataTableBehavior.prototype.renderTable = function () {
        if (this.bcDataTableConfig.multicheck) {
            this.setUpMulticheck();
        }
        if (this.bcDataTableConfig.header) {
            this.setUpHeader();
        }
        if (this.bcDataTableConfig.totalValue) {
            this.setUpTotalValue();
        }
        this.bcDataTableColumnHeaderBehavior.renderTableHead(this.bcDataTable);
        this.bcDataTableTBodyBehavior.renderHtmlTableBody(this.bcDataTable, this.bcDataTableConfig.data);
        this.setUpCommonBehaviors();
    };
    BcDataTableBehavior.prototype.setUpMulticheck = function () {
        this.bcDataTableColumnHeaderBehavior.setMultiCheck();
        this.bcDataTableTBodyBehavior.setMultiCheck(this.bcDataTable);
    };
    BcDataTableBehavior.prototype.setUpHeader = function () {
        var _this = this;
        var headerDiv = this.bcDataTableHeaderBehavior.setHeader(this.bcDataTable);
        if (this.bcDataTableConfig.multicheck) {
            this.bcDataTableHeaderBehavior.setHeaderSelection(headerDiv);
            var tabsGroup1 = document.getElementById(bc_data_table_constants_1.BcDataTableConstansts.TABS_ID);
            var tabs = new bc_tabs_group_behavior_1.BcTabsGroupBehavior();
            tabs.setElement(tabsGroup1);
            tabs.setUp();
            if (tabsGroup1) {
                this.bcDataTableHeaderBehavior.bcDataTableHeaderSelectionBehavior.onRestartClicked = function (obj) {
                    _this.handleRestartClicked(obj);
                };
            }
        }
        if (this.bcDataTableConfig.header.settings) {
            this.bcDataTableHeaderBehavior.setHeaderSettings(headerDiv);
            this.bcDataTableHeaderBehavior.bcDataTableHeaderSettingsBehavior.onApplyClicked = function () {
                var _a;
                _this.bcDataTableColumnHeaderBehavior.reset(_this.bcDataTable, false);
                if ((_a = _this.bcDataTableConfig.columnHeaders) === null || _a === void 0 ? void 0 : _a.sort) {
                    var indexColumnToSort = _this.bcDataTableTBodyBehavior.getIndexColumnToSort();
                    _this.bcDataTableTBodyBehavior.updateHtmlTableRowBySortIndex(_this.bcDataTable, indexColumnToSort);
                }
                else {
                    _this.bcDataTableTBodyBehavior.renderHtmlTableBody(_this.bcDataTable, _this.bcDataTableConfig.data);
                }
                _this.checkOverflow();
                bc_float_menu_behavior_1.BcFloatMenuBehavior.setUpAll();
            };
        }
        if (this.bcDataTableConfig.header.paginator) {
            this.bcDataTableHeaderBehavior.setHeaderPaginator(headerDiv, this.bcDataTable);
            this.initPaginators();
        }
    };
    BcDataTableBehavior.prototype.handleRestartClicked = function (obj) {
        var _a;
        this.bcDataTableColumnHeaderBehavior.reset(this.bcDataTable, false);
        this.bcDataTableMulticheckBehavior.reset();
        this.bcDataTableHeaderBehavior.bcDataTableHeaderSelectionBehavior.checkState(this.bcDataTable);
        if ((_a = this.bcDataTableConfig.columnHeaders) === null || _a === void 0 ? void 0 : _a.sort) {
            var indexColumnToSort = this.bcDataTableTBodyBehavior.getIndexColumnToSort();
            this.bcDataTableTBodyBehavior.updateHtmlTableRowBySortIndex(this.bcDataTable, indexColumnToSort);
        }
        else {
            this.bcDataTableTBodyBehavior.renderHtmlTableBody(this.bcDataTable, this.bcDataTableConfig.data);
        }
        this.checkOverflow();
    };
    BcDataTableBehavior.prototype.setUpTotalValue = function () {
        var bcTotalValueBehavior = new bc_total_value_behavior_1.BcTotalValueBehavior();
        this.bcDataTableToTalValueBehavior.setTotalValue(this.bcDataTable);
        bcTotalValueBehavior.setId('data-table-total-value-id');
        bcTotalValueBehavior.setUp();
    };
    BcDataTableBehavior.prototype.setUpCommonBehaviors = function () {
        bc_float_menu_behavior_1.BcFloatMenuBehavior.setUpAll();
        bc_checkbox_behavior_1.BcCheckboxBehavior.setUpAll();
        setTimeout(function () {
            bc_tooltip_behavior_1.BcTooltipBehavior.setUpAll();
        }, bc_data_table_constants_1.BcDataTableConstansts.WINDOW_RESIZE_TIMEOUT);
    };
    BcDataTableBehavior.prototype.initPaginators = function () {
        var _this = this;
        var paginator = new bc_paginator_v2_behavior_1.BcPaginatorV2Behavior();
        paginator.setId(this.bcDataTableConfig.header.paginator.id);
        paginator.onChangePage = function (obj) {
            _this.bcDataTableConfig.header.paginator.initialPage = obj.currentPage;
            _this.bcDataTableConfig.header.paginator.itemsPerPage = obj.itemsPerPage;
            _this.bcDataTableColumnHeaderBehavior.reset(_this.bcDataTable);
            _this.bcDataTableMulticheckBehavior.reset();
            _this.bcDataTableTBodyBehavior.renderHtmlTableBody(_this.bcDataTable, _this.bcDataTableConfig.data);
            _this.bcDataTableHeaderBehavior.bcDataTableHeaderSelectionBehavior.checkState(_this.bcDataTable);
            _this.setUpCommonBehaviors();
            _this.checkOverflow();
        };
        paginator.setUp();
    };
    BcDataTableBehavior.prototype.setPreloader = function () {
        if (bc_data_table_constants_1.BcDataTableConstansts.PRELOADER in this.bcDataTableConfig) {
            this.bcDataTableConfig.data = [];
            this.bcDataTablePreloaderBehavior.init(this.bcDataTable);
        }
    };
    BcDataTableBehavior.prototype.removePreloader = function () {
        if (!(bc_data_table_constants_1.BcDataTableConstansts.PRELOADER in this.bcDataTableConfig)) {
            var preloaderTableId = this.bcDataTablePreloaderBehavior.getPreloaderTableId();
            var preloaderTable = document.getElementById(preloaderTableId);
            if (preloaderTable) {
                preloaderTable.remove();
            }
        }
    };
    BcDataTableBehavior.prototype.checkOverflow = function () {
        if (!(bc_data_table_constants_1.BcDataTableConstansts.PRELOADER in this.bcDataTableConfig)) {
            var divContainer = this.bcDataTable.closest(common_constants_1.BcCommonConstants.DIV_TAG);
            if (divContainer.scrollWidth > divContainer.clientWidth) {
                this.bcDataTableColumnHeaderBehavior.addThStickyClass(this.bcDataTable);
                this.bcDataTableTBodyBehavior.addBodyStickyClass(this.bcDataTable);
            }
            else {
                this.bcDataTableColumnHeaderBehavior.removeThStickyClass(this.bcDataTable);
                this.bcDataTableTBodyBehavior.removeBodyStickyClass(this.bcDataTable);
            }
            this.bcDataTableColumnHeaderBehavior.checkTooltipInTitle(this.bcDataTable);
        }
    };
    return BcDataTableBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcDataTableBehavior = BcDataTableBehavior;
